<template>
  <div class="visual-scene-area">
    <div class="scene-area">
      <Scenes
        :class="getPaneStatus"
        @changePackIndex="changePackIndex"
      ></Scenes>
      <div
        class="hidescenes"
        ref="hidescenes"
        @click="togglePane"
        :class="{
          'pack-up': getPaneStatus === 'pane-leave',
          'reduce-index': getSceneLib === 'pack-enter',
        }"
      >
        <i
          :class="getPaneStatus === 'pane-enter' ? 'arrow-left' : 'arrow-right'"
        ></i>
      </div>
    </div>
    <keep-alive>
      <div
        v-if="
          getChoosedResourceType.content === 'sceneContent' && delaySceneLoad
        "
        class="scene-lib"
        :class="getSceneLib"
      >
        <globalSearchInput
          v-if="isSearchAll"
          v-model="searchingText"
          :type="titleMap[getChoosedResourceType.content].type"
        ></globalSearchInput>
        <sceneContent
          @changePackIndex="changePackIndex"
          @component-activited="componentActivited"
          ref="sceneContent"
        ></sceneContent>
      </div>
    </keep-alive>
    <div
      class="other-resources"
      :class="
        getChoosedResourceType.content !== 'sceneContent' &&
        getPaneStatus === 'pane-enter'
          ? 'pack-enter-others'
          : 'pack-leave-others'
      "
    >
      <i
        class="iconfont iconguanbianniu2 close-resource"
        v-if="!isSearchAll"
        :class="[
          getChoosedResourceType.content === 'mineContent'
            ? 'mine-close-resource'
            : '',
        ]"
        @click="closeVisualScene"
      ></i>
      <globalSearchInput
        v-if="isSearchAll"
        v-model="searchingText"
        :type="titleMap[getChoosedResourceType.content].type"
        :placeholder="'搜索' + titleMap[getChoosedResourceType.content].text"
      ></globalSearchInput>
      <i
        :class="getPaneStatus === 'pane-enter' ? 'arrow-left' : 'arrow-right'"
      ></i>
      <keep-alive>
        <templateContent
          v-if="getChoosedResourceType.content === 'templateContent'"
          @search="onSearch"
          @listsUpdate="onListsUpdate"
          @changePackIndex="changePackIndex"
          @component-activited="componentActivited"
          ref="templateContent"
        ></templateContent>
      </keep-alive>
      <keep-alive>
        <bgContent
          ref="bgContent"
          v-if="getChoosedResourceType.content === 'bgContent'"
          @changePackIndex="changePackIndex"
          @component-activited="componentActivited"
        ></bgContent>
      </keep-alive>
      <keep-alive>
        <wordContent
          ref="wordContent"
          v-if="getChoosedResourceType.content === 'wordContent'"
          @search="onSearch"
          @component-activited="componentActivited"
        ></wordContent>
      </keep-alive>
      <keep-alive>
        <roleContent
          ref="roleContent"
          v-if="getChoosedResourceType.content === 'roleContent'"
          @search="onSearch"
          @component-activited="componentActivited"
        ></roleContent>
      </keep-alive>
      <keep-alive>
        <visualContent
          ref="visualContent"
          v-if="getChoosedResourceType.content === 'visualContent'"
          @component-activited="componentActivited"
        ></visualContent>
      </keep-alive>
      <keep-alive>
        <musicContent
          ref="musicContent"
          v-if="getChoosedResourceType.content === 'musicContent'"
          @search="onSearch"
          @listsUpdate="onListsUpdate"
          @component-activited="componentActivited"
        ></musicContent>
      </keep-alive>
      <keep-alive>
        <mineContent
          ref="mineContent"
          v-if="getChoosedResourceType.content === 'mineContent'"
        ></mineContent>
      </keep-alive>
      <div
        class="global-search-entry"
        ref="globalSearchEntry"
        v-show="false && searchingText && !isSearchAll"
        @click="mySearchAll()"
      >
        <div class="btn">在全局搜索“{{ searchingText }}”</div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import close from "../common/close.vue";
import Scenes from "../Scenes.vue";
import sceneContent from "./sceneContent.vue";

export default {
  name: "VisualArea",
  components: {
    templateContent: () => import("./templateContent.vue"),
    bgContent: () => import("./bgContent.vue"),
    wordContent: () => import("./wordContent.vue"),
    roleContent: () => import("./roleContent.vue"),
    visualContent: () => import("./visualContent.vue"),
    musicContent: () => import("./musicContent.vue"),
    mineContent: () => import("./mineContent.vue"),
    globalSearchInput: () => import("./globalSearchInput.vue"),
    close,
    Scenes,
    sceneContent,
  },
  data() {
    return {
      maxPaneWidth: 378,
      minPaneWidth: 88,
      titleMap: {
        templateContent: {
          text: "模板",
          libNav: "template",
          type: "template",
          show: true,
        },
        bgContent: {
          text: "背景",
          libNav: "background",
          type: "background",
          show: true,
        },
        wordContent: { text: "文字", libNav: "text", type: "text", show: true },
        roleContent: {
          text: "角色",
          libNav: "roles",
          type: "character",
          show: true,
        },
        visualContent: {
          text: "素材",
          libNav: "props",
          type: "material",
          show: true,
        },
        musicContent: {
          text: "音乐",
          libNav: "music",
          type: "sound",
          show: true,
        },
        sceneContent: {
          text: "场景",
          libNav: "scene",
          type: "scene",
          show: true,
        },
      },
      delaySceneLoad: false,
    };
  },
  computed: {
    ...mapGetters({
      getResourceTypes: "materialArea/getResourceTypes",
      getChoosedResourceType: "materialArea/getChoosedResourceType",
      getPaneStatus: "materialArea/getPaneStatus",
      getSceneLib: "materialArea/getSceneLib",
      TOOL: "TOOL",
      isSearchAll: "resources/isSearchAll",
      globalKeyword: "resources/globalKeyword",
      textAllData: "textContent/allData",
    }),
    searchingText: {
      get() {
        return this.globalKeyword;
      },
      set(val) {
        this.setGlobalKeyword(val);
      },
    },
  },
  watch: {
    getChoosedResourceType() {
      if (this.getPaneStatus === "pane-leave") {
        this.togglePane();
      }
    },
  },
  created() {
    this.$bus.on("globalSearchEntry.updatePosition", this.onListsUpdate);
  },
  mounted() {
    this.delaySceneLoad = true;
    this.$bus.on('open-resource-area', ({index, callbackFunc, props}) => {
      this.openResourceArea({index, callbackFunc, props});
    });
  },
  beforeDestroy() {
    this.$bus.off("globalSearchEntry.updatePosition", this.onListsUpdate);
    this.$bus.off("open-resource-area", ({ index, callbackFunc, props }) => {
      this.openResourceArea({ index, callbackFunc, props });
    });
  },
  methods: {
    ...mapMutations({
      setResourceTypes: "materialArea/setResourceTypes",
      setChoosedResourceType: "materialArea/setChoosedResourceType",
      setPaneStatus: "materialArea/setPaneStatus",
      setGlobalKeyword: "resources/setGlobalKeyword",
    }),
    ...mapActions({
      searchAll: "resources/searchAll",
      openLib: "resources/openLib",
    }),
    componentActivited (index) {
      let panel = this.getResourceTypes[index];
      let targetP = this.$refs[panel.content] || this.$refs[panel.content][0];
      let callbackFunc = panel.queue.name || '';
      let props = panel.queue.props;
      if (callbackFunc) {
          targetP[callbackFunc](props);
        } else {
          targetP.chooseTab('collect');
      }
      this.setResourceTypes({index, data: {
        queue: null
      }});
    },
    openResourceArea({ index, callbackFunc, props }) {
      if (this.getPaneStatus === "pane-leave") {
        this.togglePane();
      }
      let panel = this.getResourceTypes[index];
      panel.queue = {
        name: callbackFunc || '',
        props
      };
      this.setChoosedResourceType(panel);
      this.$nextTick(() => {
        if (!this.$refs[panel.content]) {
          return;
        }
        let targetP = this.$refs[panel.content] || this.$refs[panel.content][0];
        if (callbackFunc) {
          targetP[callbackFunc](props);
        } else {
          targetP.chooseTab('collect');
        }
      });
    },
    changePackIndex(val) {
      // 动态修改hidescenes的zIndex值
      let hideScenes = this.$refs["hidescenes"];
      hideScenes.style.zIndex = val; // 14 16
    },
    closeVisualScene() {
      this.setChoosedResourceType({
        name: "场景",
        key: "scene",
        content: "sceneContent",
        icon: "iconchangjing",
        index: 0,
      });
    },
    togglePane() {
      let val =
        this.getPaneStatus === "pane-enter" ? "pane-leave" : "pane-enter";
      this.setPaneStatus(val);
      this.$store.commit("save_MaterialPane", {
        width:
          this.getPaneStatus === "pane-enter"
            ? this.maxPaneWidth
            : this.minPaneWidth,
      });
      this.$bus.emit("EditorSetOption_vue", {
        data: true,
        source: "MaterialPane",
      });
    },
    onSearch(val = "") {
      // if (this.isSearchAll) {
      //   return;
      // }
      // this.searchingText = decodeURI(val);
    },
    mySearchAll() {
      // this.searchAll({keyword: this.searchingText});
      this.$store.commit("resources/setIsSearchAll", true);
    },
    onListsUpdate(el, classname) {
      this.entryPositionParams = [el, classname];
      if (!el.offsetHeight || this.isSearchAll) {
        this.$refs.globalSearchEntry.style.bottom = "";
        this.$refs.globalSearchEntry.style.top = "";
        return;
      }
      let children = [...el.children];
      if (classname) {
        children = children.filter((v) => {
          return v.classList.contains(classname);
        });
      }
      let len = children.length;
      let last = children[len - 1];
      if (!last) {
        this.$refs.globalSearchEntry.style.bottom = "";
        this.$refs.globalSearchEntry.style.top = "";
        return;
      }
      let childRect = last.getBoundingClientRect();
      let rect = el.getBoundingClientRect();
      let contentHeight = childRect.bottom - rect.top;
      let delta = el.offsetHeight - contentHeight;
      let parentRect = el.closest(".other-resources").getBoundingClientRect();
      let offset = rect.top - parentRect.top;
      if (delta > 100) {
        this.$refs.globalSearchEntry.style.bottom = "auto";
        this.$refs.globalSearchEntry.style.top = offset + contentHeight + "px";
      } else {
        this.$refs.globalSearchEntry.style.bottom = "";
        this.$refs.globalSearchEntry.style.top = "";
      }
    },
    onResize() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.onListsUpdate(...this.entryPositionParams);
      }, 220);
    },
  },
};
</script>
<style lang="scss" scoped>

.visual-scene-area {
  position: relative;
  width: 307px;
  height: 100%;
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  /deep/ .btn-more {
    position: absolute;
    left: 50px;
    bottom: 40px;
    z-index: 15;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 187px;
    height: 40px;
    background: #5778fb;
    opacity: 1;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #7d95f5;
    }
  }
  .mine-close-resource {
    top: 66px !important;
  }
  /deep/ .close-resource {
    position: absolute;
    top: 16px;
    right: 0;
    z-index: 15;
    width: 33px;
    height: 33px;
    border-radius: 100% 0 0 100%;
    line-height: 33px;
    text-align: center;
    background-color: #fafaff;
    font-size: 12px;
    color: #737596;
    cursor: pointer;
  }
  /deep/ .resources-detail {
    width: 290px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    position: relative;
    .visual-scene-lists {
      position: relative;
      flex-grow: 1;
      overflow-x: hidden;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      margin: 0 9px;
      padding-bottom: 100px;

      &.Horizontal {
        li {
          width: 262px;
          height: 148px;
        }
      }
      &.Vertical {
        li {
          width: 126px;
          height: 224px;
        }
      }
      &.Mixed {
        height: 500px;
        li.direction-1 {
          width: 126px;
          height: 70.88px;
        }
        li.direction-2 {
          width: 126px;
          height: 224px;
        }
        // li:nth-child(2n+1) {
        //   order: 1;
        // }
        // li:nth-child(2n) {
        //   order: 2;
        // }
      }
      li {
        background: #ffffff;
        border: 1px solid #d9ddea;
        border-radius: 4px;
        margin: 0 5px 10px 5px;
        cursor: pointer;
        .li-inner {
          position: relative;
          width: 100%;
          height: 100%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          border-radius: 4px;
          &:hover {
            z-index: 13;
          }
        }
        video {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }
    }
    .display-img .collection-active {
      color: #fd6c6c !important;
    }
    .display-img .collection {
      display: none;
      position: absolute;
      right: 6px;
      top: 6px;
      color: #fff;
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      background: rgba($color: #6e6e6e, $alpha: 0.8);
      border-radius: 50%;
      z-index: 9;

      > span {
        display: block;
        transform: scale(0.5);
        font-size: 20px;
        position: relative;
        left: -1px;
      }
      &:hover {
        background-color: #6565ff;
      }
    }
    .pad-14 {
      padding: 0 14px;
    }
  }
 /deep/ .right-bottom-controls {
      position: absolute;
      z-index: 10;
      right: 6px;
      bottom: 6px;
      color: #fff;
      display: flex;
      align-items: center;
      .business {
        background-image: url(../../../static/svg/resources-area/business.svg);
        display: block;
        width: 20px;
        height: 20px;
        background-position: center center;
        background-size: 100%;
        background-color: #fff;
        border-radius: 100%;
      }
      .AI-business {
        background-image: url(../../../static/img/Ai.png);
        display: block;
        width: 20px;
        height: 20px;
        background-position: center center;
        background-size: 100%;
        background-color: #fff;
        border-radius: 100%;
      }
      .templatePayTypeSubscript {
        div {
          margin-left: 6px;
        }
      }
      .member {
        height: 20px;
        line-height: 17px;
        padding: 0 9px;
        background: #2f58fe;
        border: 1px solid #ffffff;
        opacity: 1;
        border-radius: 11px;
        font-size: 12px;
      }
    }
    /deep/ .right-top-controls {
      height: 22px;
      padding-top: 6px;
      padding-right: 6px;
      position: absolute;
      z-index: 12;
      right: 0;
      top: 0;
      display: flex;
      .collect,
      .more {
        width: 22px;
        height: 22px;
        color: #fff;
        background-color: #6e6e6e;
        text-align: center;
        line-height: 22px;
        &:hover {
          background-color: #6565ff;
        }
      }
      .collect {
        border-radius: 100%;
        &.active {
          color: #fd6c6c;
        }
        i {
          font-size: 20px;
          transform: scale(0.5);
          display: block;
          position: relative;
          left: -1px;
          top: 1px;
        }
      }
      .more {
        border-radius: 100%;
        margin-left: 8px;
        &:hover {
          .adsorb {
            display: block;
          }
        }
        i {
          font-size: 12px;
          transform: scale(0.6);
          display: block;
          position: relative;
          left: -6px;
        }
      }
    }
  /deep/ .dropdown-label {
    color: #474261;
    height: 100%;
    padding-left: 10px;
    padding-right: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    border-radius: 4px 0 0 4px;
    &.no-drop {
      padding-left: 0;
    }
    span {
      font-size: 12px;
      word-break: keep-all;
    }
    i {
      transform: scale(0.6);
      font-size: 12px;
      margin-left: -2px;
    }
    &:hover {
      .dropdown {
        display: block;
      }
    }
  }
  .hidescenes {
    position: relative;
    left: 0;
    z-index: 14;
    display: flex;
    align-items: center;
    width: 17px;
    height: 55px;
    background: url("../../../static/svg/pane-arrow-left.svg") no-repeat center;
    cursor: pointer;
    &.pack-up {
      background: url("../../../static/svg/pane-arrow-left-packed.svg")
        no-repeat center;
    }
    &:hover {
      .arrow-left {
        background: url("../../../static/svg/left-arrow.svg") no-repeat center;
      }
      .arrow-right {
        background: url("../../../static/svg/right-arrow.svg") no-repeat center;
      }
    }
    &.reduce-index {
      z-index: 10;
    }
    i {
      display: block;
      width: 6px;
      height: 10px;
      margin-left: 3px;
    }
    .arrow-left {
      background: url("../../../static/svg/left-arrow-active.svg") no-repeat
          center;
    }
    .arrow-right {
      background: url("../../../static/svg/right-arrow-active.svg") no-repeat
          center;
    }
  }
  .other-resources {
    display: flex;
    flex-direction: column;
    width: 290px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 15;
    background-color: #fff;
  }
  .scene-lib {
    position: absolute;
    left: 290px;
    top: 0;
    z-index: 10;
    width: 290px;
    height: 100%;
    transform: translate(-581px, 0);
    border-left: 1px solid #d1d4dd;
  }
}
.scene-area {
  width: 307px;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  position: relative;
}

.global-search-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 30;
  width: 100%;
  height: 50px;
  cursor: pointer;
  background-color: #fff;
  & > .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 262px;
    height: 30px;
    background: #f2f3f7;
    opacity: 1;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    &:hover {
      width: 262px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #5778fb;
      opacity: 1;
      color: #5778fb;
    }
  }
}
</style>
<style>
.pack-enter {
  animation: pack-in 0.3s ease-in forwards;
}

.pack-leave {
  animation: pack-in-reverse 0.3s ease-out forwards;
}
.pack-enter-others {
  animation: pack-in-others 0.2s ease-in forwards;
}

.pack-leave-others {
  animation: pack-in-others-reverse 0.2s ease-out forwards;
}

.pane-enter {
  animation: pane-in 0.2s ease-in forwards;
}

.pane-leave {
  animation: pane-in-reverse 0.2s ease-out forwards;
}

@keyframes pack-in {
  0% {
    transform: translate(-581px, 0);
  }
  20% {
    transform: translate(-291px, 0);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes pack-in-reverse {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-291px, 0);
  }
  100% {
    transform: translate(-581px, 0);
  }
}
@keyframes pack-in-others {
  0% {
    transform: translate(-291px, 0);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes pack-in-others-reverse {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-291px, 0);
  }
}
@keyframes pane-in {
  0% {
    width: 0;
  }

  100% {
    width: 290px;
  }
}
@keyframes pane-in-reverse {
  0% {
    width: 290px;
  }

  100% {
    width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/visualSceneArea.vue